// src/components/Sidebar.js
import { Link, useNavigate } from 'react-router-dom';

const Sidebar = () => {
  const navigate = useNavigate();

  const handleLogout = () => {
    // Clear all data from localStorage
    window.localStorage.clear();
    // Redirect to login page
    navigate('/');
  };

  return (
    <div className="col-md-3 bg-dark min-vh-100 p-3">
      <nav className="nav flex-column">
        <Link to="/main" className="nav-link text-white">Home</Link>
        <Link to="/playlists" className="nav-link text-white">Playlists</Link>
        <Link to="/podcasts" className="nav-link text-white">Podcasts</Link>
        <Link to="/albums" className="nav-link text-white">Albums</Link>
        <Link to="/artists" className="nav-link text-white">Artists</Link>
        
        {/* Add a divider */}
        <hr className="bg-secondary my-3" />
        
        {/* Add logout button */}
        <button 
          onClick={handleLogout}
          className="btn btn-outline-danger mt-auto col-md-3"
        >
          Logout
        </button>
      </nav>
    </div>
  );
};

export default Sidebar;